// extracted by mini-css-extract-plugin
export default {"root":"b1RmBZHsOCIj0a9TjMtI","header":"YI9gCBv53JtESvJZB_QQ","underLine":"Ao_hk4BQED2dIkVrCC1M","content":"U94SAXOwjTb0jBTRuKE9","secondary":"J78NTRD_aRowSjAFuOja"};